import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreTypes } from '../storeTypes.enum';
import { RmmGroupTaskWizardEffects } from './effects';
import { groupActionWizardReducer } from './reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(StoreTypes.RmmGroupActionWizard, groupActionWizardReducer),
    EffectsModule.forFeature([RmmGroupTaskWizardEffects])
  ]
})
export class RmmGroupActionWizardStoreModule {}
